module.exports = __webpack_public_path__ + "static/media/max.067dee56.jpg";